import '../css/app.css'
import Bugsnag from '@bugsnag/js'
import './navigation.js'
import './sitewide.js'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  enabledReleaseStages: ['production', 'staging'],
  releaseStage: import.meta.env.MODE,
})
